import { Button, FormTextField, FormTextFieldProps, InputAdornment } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';

export interface AmountFieldProps extends FormTextFieldProps {
  currency?: string | null | undefined;
  onMaxClick?: () => void;
}

export function AmountField({ currency, onMaxClick, ...props }: AmountFieldProps) {
  const { t } = useTranslation();

  return (
    <FormTextField
      autoComplete="off"
      {...props}
      InputProps={{
        ...props.InputProps,
        startAdornment: currency ? (
          <InputAdornment position="start" disableTypography sx={{ color: 'text.primary' }}>
            {currency}
          </InputAdornment>
        ) : (
          props.InputProps?.startAdornment
        ),
        endAdornment: onMaxClick ? (
          <Button variant="text" color="inherit" onClick={onMaxClick}>
            {t('Max')}
          </Button>
        ) : null,
      }}
      inputProps={{ inputMode: 'decimal' }}
    />
  );
}
